import React, { ReactElement } from 'react';
import FsDefaultDialog from '../FsDefaultDialog';

interface FsConfirmationDialogProps {
  title: string;
  showModal: boolean;
  setShowModal: (status: boolean) => void;
  actionButtons?: ReactElement[];
}

const FsConfirmationDialog: React.FC<FsConfirmationDialogProps> = ({
  showModal,
  setShowModal,
  title,
  actionButtons,
  children,
}) => {
  return (
    <FsDefaultDialog
      disableBackdropClick
      disableEscapeKeyDown
      title={title}
      isOpen={showModal}
      fullWidth
      maxWidth="sm"
      actionButtons={actionButtons}
      onClose={() => setShowModal(false)}
    >
      {children}
    </FsDefaultDialog>
  );
};

export default FsConfirmationDialog;
